import { useEffect, useRef } from "react";
import { animated } from "@react-spring/three";
import * as THREE from 'three';
import AtmosphereFragmentShader from '../shader/moon/atmosphere/fragment.glsl'
import AtmosphereVertexShader from '../shader/moon/atmosphere/vertex.glsl'
import FragmentShader from '../shader/moon/fragment.glsl'
import VertexShader from '../shader/moon/vertex.glsl'
import { useFrame } from "@react-three/fiber";
import { useAtomValue } from "jotai";
import { moonTextureAtom } from "../GlobalState";

export default function Moon({ position=[0,0,0], rotation=[0,0,0], scale=1, shiny=true, opacity=1, atmosphereColor='#D0D0D0', atmosphereOpacity=1, rotationSpeed=0.5 }) {
  const moonTexture = useAtomValue(moonTextureAtom);

  const moon = useRef();
  const moonMaterial = useRef();
  const atmosphereMaterial = useRef();
  function updateOpacity(material, nextOpacity) {
    const opacityUniform = material?.uniforms?.uOpacity
    if (opacityUniform && opacityUniform.value !== nextOpacity) {
      opacityUniform.value = nextOpacity
      material.needsUpdate = true
    }
  }

  useFrame((state) => {
    if (moon.current) moon.current.rotation.y = state.clock.elapsedTime * rotationSpeed;
    updateOpacity(moonMaterial.current, opacity)
    updateOpacity(atmosphereMaterial.current, atmosphereOpacity)
  });

  useEffect(() => {
    updateOpacity(moonMaterial.current, opacity)
    updateOpacity(atmosphereMaterial.current, atmosphereOpacity)
  }, [atmosphereOpacity, opacity]);

  return (
    <animated.group
      ref={moon}
      position={position}
      rotation={rotation}
      scale={scale}
    >
      <group scale={3.4}>
        <mesh>
          <sphereGeometry args={[0.6, 32, 32]} />
          <shaderMaterial
            ref={moonMaterial}
            transparent
            vertexShader={VertexShader}
            fragmentShader={FragmentShader}
            uniforms={{
              uSunDirection: new THREE.Uniform(new THREE.Vector3(0,0,0)),
              uMoonTexture: new THREE.Uniform(moonTexture),
              uAtmosphereDayColor: new THREE.Uniform(new THREE.Color(atmosphereColor)),
              uAtmosphereTwilightColor: new THREE.Uniform(new THREE.Color(atmosphereColor)),
              uOpacity: new THREE.Uniform(opacity)
            }}
          />
        </mesh>
        { shiny && <mesh scale={1.5}>
          <sphereGeometry args={[0.6, 32, 32]} />
          <shaderMaterial 
          ref={atmosphereMaterial}
          side={THREE.BackSide} 
          transparent 
          vertexShader={AtmosphereVertexShader}
          fragmentShader={AtmosphereFragmentShader}
          uniforms={{
            uSunDirection: new THREE.Uniform(new THREE.Vector3(0,0,0)),
            uAtmosphereDayColor: new THREE.Uniform(new THREE.Color(atmosphereColor)),
            uAtmosphereTwilightColor: new THREE.Uniform(new THREE.Color(atmosphereColor)),
            uOpacity: new THREE.Uniform(atmosphereOpacity)
          }}
          />
        </mesh> }
      </group>
    </animated.group>
  );
}